import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export interface FormFieldsetProps extends ChakraV3.FieldsetRootProps {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  extra?: React.ReactNode;
}

/**
 * Used for checkboxes, radios, switches.
 * See https://chakra-ui.com/docs/components/checkbox#checkboxgroup--field-vs-fieldset
 */

export const FormFieldset = (props: React.PropsWithChildren<FormFieldsetProps>) => {
  const { label, helperText, errorText, extra, children, ...rest } = props;

  return (
    <ChakraV3.Fieldset.Root {...rest}>
      <ChakraV3.HStack align='start'>
        <ChakraV3.Fieldset.Legend>{label}</ChakraV3.Fieldset.Legend>
        <ChakraV3.Spacer />
        {extra}
      </ChakraV3.HStack>
      {children}
      {helperText && <ChakraV3.Fieldset.HelperText>{helperText}</ChakraV3.Fieldset.HelperText>}
      {errorText && <ChakraV3.Fieldset.ErrorText>{errorText}</ChakraV3.Fieldset.ErrorText>}
    </ChakraV3.Fieldset.Root>
  );
};
